/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($,w,SCS) {
	'use strict';
	/*globals Tc,doT,debug,tvDialogs */

	/**
	 * Stage Carousel.
	 *
	 * @author Dave Talamona
	 * @namespace Tc.Module
	 * @class StageCarousel
	 * @extends Tc.Module
	 */

	Tc.Module.StageCarousel = Tc.Module.extend({

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this;

			mod.initialize();

			callback();
		},

		initialize: function() {
			var mod = this,
				initialPosition = 1,
				initialized = false,
				carousel,
				wrapper = this.$ctx.parents('.stageCarousel-wrapper'),
				slideList = this.$ctx.find('ul.carousel-list > li');
			if (slideList.length <= 2) {
				initialPosition = 0;
			}

			carousel = mod.$ctx.stageCarousel_scCarousel({
				position: initialPosition,
				onBeforeAnimation: function (carousel, activeItem, futureItem, newPos, oldPos, totalListItems) {
					if (initialized) {
						$(activeItem)
							.removeClass('active')
							.transition({ opacity: 0.34 }, carousel.options.animation.duration, carousel.options.animation.easing);
						$(futureItem)
							.addClass('active')
							.transition({ opacity: 1 }, carousel.options.animation.duration, carousel.options.animation.easing);
						wrapper.find('.slide-background-image').each(function(){
							var img = $(this);
							if (img.hasClass('index-' + newPos)) {
								img.addClass('active');
							} else {
								img.removeClass('active');
							}
						});

					}
				},
				onAfterInit: function() {
					slideList.each(function(index) {
						$(this).find('.slide-background-image').each(function() {
							var img = $(this);
							img.addClass('index-' + index);
							if (index == initialPosition) {
								img.addClass('active');
							}
							wrapper.prepend(img.detach());
						});
					});
					wrapper.siblings('.stageCarousel-place-holder').height(wrapper.height());
				}
			});

			// activate item at the initial position
			mod.$ctx.find('.carousel-list > li:eq(' + initialPosition + ')').addClass('active').css('opacity', 1);

			// prevent klicks on "inactive" items
			// open links in snoopy-overlays
			mod.$ctx.on('click', '.carousel-list a', function (e) {
				if (!$(this).hasClass('allow-default-event') && !$(this).hasClass('action-link')) {
					e.preventDefault();
				}
			});

			initialized = true;
		}
	});
})(Tc.$, window, window.SCS = window.SCS || {});





/*
* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* The following carousel is a copy of the old scCarousel (before swipe-refactoring) and is only used for the
* Tc.Module.StageCarousel because the principle this carousel is not possible to realize with the new one.
* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* */

(function ($) {
	/**
	 * Swisscom Carousel
	 *
	 * @author David Talamona
	 * @namespace SCS
	 * @class stageCarousel_scCarousel
	 */
	"use strict";

	var defaults = {
		selectors: {
			prevButton: '.carousel-prev',
			nextButton: '.carousel-next',
			disabledButton: '.disabled',
			pagerItems: '.carousel-control > a',
			clip: '.carousel-clip',
			list: 'ul.carousel-list',
			listItems: '',								// optional, by default the direct children of the list are taken
			otherFocusGrabbers: []
		},
		setItemWidth: false,
		pagerItemsActiveCls: 'selected',
		position: 0,
		noItemsCls: 'noScrolling',
		disabledButtonCls: 'disabled',
		animation: {
			duration: 500,
			easing: ''
		}
	};

	var carousel = function (e, o) {
		var me = this; // local scope inside cascaded functions

		this.options = $.extend({}, defaults, o || {});
		this.container = $(e);
		this.clip = this.container.find(this.options.selectors.clip);
		this.list = this.clip.find(this.options.selectors.list);
		this.listItems = this.options.selectors.listItems && this.options.selectors.listItems.length ? this.list.find(this.options.selectors.listItems) : this.list.children();

		// get navigation-buttons and paging-navigation
		this.prevButton = this.container.find(this.options.selectors.prevButton);
		this.nextButton = this.container.find(this.options.selectors.nextButton);
		this.pagingItems = this.container.find(this.options.selectors.pagerItems);

		// find and store all link items
		this.linkItems = this.listItems.find('A');

		// disable tabbing to all links
		this.linkItems.attr('tabindex', -1);

		// definitions
		this.position = this.options.position;
		this.isAnimating = false;

		// initial DOM manipulations
		this.listItemWidth = Math.max(this.clip.width(), this.options.setItemWidth ? 0 : this.listItems.filter(':eq(0)').outerWidth(true));
		this.list.width((this.listItemWidth + 10) * this.listItems.length); // 10 px addition for tolerance
		if (this.options.setItemWidth) {
			// recalculate itemWidth because scrollbar might have been gone after setting the list-width to "infinity"
			this.listItemWidth = this.clip.width();
			this.list.width((this.listItemWidth + 10) * this.listItems.length); // 10 px addition for tolerance
			// set width of the list-items
			this.listItems.width(this.listItemWidth);
		}
		if (this.listItems.length <= 1) {
			this.container.addClass(this.options.noItemsCls);
		}
		this.updateNavigationStates();

		// bind events to the navigation buttons
		this.prevButton.on('click', function (e) {
			e.preventDefault();
			if (!me.prevButton.hasClass(me.options.selectors.disabledButton)) {
				me.slideTo(me.position - 1);
			}
		});
		this.nextButton.on('click', function (e) {
			e.preventDefault();
			if (!me.nextButton.hasClass(me.options.selectors.disabledButton)) {
				me.slideTo(me.position + 1);
			}
		});

		// bind events to the pagination
		this.pagingItems.each(function (i) {
			$(this).data('carousel-paging-index', i);
		});
		this.pagingItems.on('click', function (e) {
			me.slideTo($(this).data('carousel-paging-index'));
			e.preventDefault();
		});

		// bind keyboard events
		if (!this.options.selectors.otherFocusGrabbers) {
			this.options.selectors.otherFocusGrabbers = [];
		}
		this.container.add(this.options.selectors.otherFocusGrabbers.join(', ')).on('keyup', function (e) {
			if (e.which === 37) { // LEFT
				me.slideTo(me.position - 1);
			} else if (e.which === 39) { // RIGHT
				me.slideTo(me.position + 1);
			}
		});

		if (this.position > -1) {
			$.fx.off = true;
			me.slideTo(me.position);
			$.fx.off = false;
			me.isAnimating = false;
		}

		this.fireEvent('onAfterInit');
	};

	$.extend(carousel.prototype, {

		fireEvent: function () {
			// convert arguments-object (is not a real array) into an array
			var params = [];
			for (var i=0; i < arguments.length; i++) {
				params.push(arguments[i]);
			}

			var event = params.shift();

			if (typeof this.options[event] === 'function') {
				params.unshift(this);
				this.options[event].apply(this.container[0], params);
			}
		},

		updateNavigationStates: function () {
			this.prevButton[this.position > 0 ? 'removeClass' : 'addClass'](this.options.disabledButtonCls);
			this.nextButton[this.position+1 < this.listItems.length ? 'removeClass' : 'addClass'](this.options.disabledButtonCls);
			this.pagingItems
				.removeClass(this.options.pagerItemsActiveCls)
				.filter(':eq(' + this.position + ')').addClass(this.options.pagerItemsActiveCls);
		},

		slideTo: function (newPos) {
			newPos = newPos < 0 ? 0 : (newPos > this.listItems.length-1 ? this.listItems.length-1 : newPos);
			if (this.isAnimating) {
				return;
			}
			var me = this; // local scope inside cascaded functions
			var activeItem = this.listItems.filter(':eq(' + this.position + ')');
			var futureItem = this.listItems.filter(':eq(' + newPos + ')');
			this.fireEvent('onBeforeAnimation', activeItem[0], futureItem[0], newPos, this.position, this.listItems.length);
			var oldPos = this.position;
			this.position = newPos;
			this.updateNavigationStates();
			if (typeof futureItem.position() !== 'undefined') {
				this.list.transition({'right': futureItem.position().left + 'px'}, this.options.animation.duration, this.options.animation.easing, function () {
					me.isAnimating = false;
					me.fireEvent('onAfterAnimation', activeItem[0], futureItem[0], me.position, oldPos, me.listItems.length);
				});
				this.isAnimating = true;
			}
		},

		updateWidth: function (newItemWidth) {
			this.listItemWidth = newItemWidth ? newItemWidth : this.clip.width();
			if (this.options.setItemWidth) {
				this.listItems.width(this.listItemWidth);
			}
			this.list.width((this.listItemWidth + 10) * this.listItems.length); // 10 px addition for tolerance
			// stop currently running animation
			this.list.stop(true);
			this.isAnimating = false;
			// set list-position to the new position regarding the new item-sizes
			var activeItem = this.listItems.filter(':eq(' + this.position + ')');
			this.list.css({'right': activeItem.position().left + 'px'});
		}

	});

	$.fn.stageCarousel_scCarousel = function (o) {
		var $this = $(this);
		if ($this.length === 1 && $this.data('stageCarousel_scCarousel')) {
			return $this.data('stageCarousel_scCarousel');
		} else {
			return this.each(function () {
				var $this = $(this);
				if (!$this.data('stageCarousel_scCarousel')) {
					$this.data('stageCarousel_scCarousel', new carousel(this, o));
				}
			});
		}
	};

})(Tc.$);
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.StageCarousel.js
// module id = 184
// module chunks = 0